import * as React from 'react';
import { observer } from 'mobx-react';

import { PageConfirmBankAccountViewModel } from './page-confirm-bank-account-view-model';
import { WebGivingUserAction } from '../../webgiving-user-actions';
import { SubmitButton } from '../../components/submit-button/submit-button';
import { Form } from '../../primitives/form';
import { LeftChevronLink } from '../../primitives/link/link';
import { ErrorMessage } from '../../components/error-message/error-message';
import { AccountNumberInput } from '../../components/account-number-input';
import { FadeTransition } from '../../components/fade-transition';
import { PanelContentTransition } from '../../components/panel-content-transition';
import { getPageClasses} from '../helpers/get-page-classes';
import { PanelHeading } from '../../components/panel-heading';
import { injectWebGivingProps, InjectableWebGivingProps, raiseAction } from '../../utils/injectable-props';
import { PanelFooter } from '../../components/panel-footer';
import { Text } from '../../components/text';

import { pageFooter } from '../../main/webgiving-main.less';

export { PageConfirmBankAccountViewModel };

@injectWebGivingProps
@observer
export class PageConfirmBankAccount extends React.Component<{
	vm: PageConfirmBankAccountViewModel,
	transitionState: string,
} & InjectableWebGivingProps> {
	panelBodyNode: HTMLDivElement;

	render() {
		const { vm, transitionState } = this.props;
		const { accountNumberConfirm, error, bankName, isLoading, pageShouldBeVisible, isBlocked } = vm;
		const elementsShouldEnter = transitionState === 'entered';

		return (
			<div className={getPageClasses(pageShouldBeVisible, isLoading)} data-pp-at-target={pageShouldBeVisible ? `Confirm Bank Account page` : null}>
				<PanelHeading vm={vm}>
					<FadeTransition in={elementsShouldEnter}>
						<div>
							<h1 className="panel-title"><Text>PAYMENT METHOD</Text></h1>
							<p className="panel-subtitle"><Text>Please confirm your account number for </Text><strong>{bankName}</strong>.</p>
							<LeftChevronLink acceptanceTestTargetId="change-account-number-link" onClick={this.handleChangeAccountDetails} branded={false}><Text>Change bank account details</Text></LeftChevronLink>
						</div>
					</FadeTransition>
				</PanelHeading>
				<Form onSubmit={this.handleSubmit}>
					<div className="panel-body panel-body-form" ref={this.savePanelBodyNode}>
						<PanelContentTransition in={elementsShouldEnter} setContentHeight={this.setContentHeight} className="panel-body-content">
							<div>
								<ErrorMessage error={error} />
								<div className="row">
									<div className="col-sm-8 col-centered">
										<AccountNumberInput
											value={accountNumberConfirm}
											formControlId="ach-account-number-confirm"
											label="Confirm your account number"
											focusOnMount
											acceptanceTestTargetId="Confirm ACH Account Number"
										/>
									</div>
								</div>
							</div>
						</PanelContentTransition>
					</div>
					<PanelFooter className={pageFooter}>
						<SubmitButton acceptanceTestTargetId="Next" isLoading={isLoading} isBlocked={isBlocked}><Text>Next</Text></SubmitButton>
					</PanelFooter>
				</Form>
			</div>
		);
	}

	setContentHeight = (offsetHeight: number) => {
		if (this.panelBodyNode) {
			this.panelBodyNode.style.minHeight = `${offsetHeight}px`;
		}
	}

	private savePanelBodyNode = (panelBodyNode: HTMLDivElement) => this.panelBodyNode = panelBodyNode;

	private handleChangeAccountDetails = (event: React.MouseEvent<HTMLAnchorElement>) => {
		raiseAction(new WebGivingUserAction.ChangeBankDetails(), this.props);
	}

	private handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
		raiseAction(new WebGivingUserAction.SubmitCurrentPage(), this.props);
	}
}
